import React, { useEffect, useState } from 'react';

import NotificationMessage, {
  type NotificationVariant,
} from 'components/partials/notification/notification';

import Notification from 'components/partials/notification/notification.helper';
import type { NotificationData } from 'components/partials/notification/notification.helper';

const DEFAULT_FLASH_DURATION_MS = 5000;

interface FlashNotificationProps {
  customClass?: string;
  children?: React.ReactNode;
}

const FlashNotification = ({
  customClass = '',
  children,
}: FlashNotificationProps): React.JSX.Element | null => {
  const [{ heading, message, variant, duration }, setNotification] =
    useState<NotificationData>(Notification.notification);

  const removeNotification = () => {
    setNotification({});
    Notification.clear();
  };

  useEffect(() => {
    const currentNotification = Notification.notification;

    if (
      currentNotification.heading &&
      currentNotification.heading !== heading
    ) {
      setNotification(currentNotification);
    }
  }, []);

  useEffect(() => {
    if (!heading) return undefined;

    const timer = setTimeout(
      removeNotification,
      duration ?? DEFAULT_FLASH_DURATION_MS
    );

    return () => clearTimeout(timer);
  }, [heading, duration]);

  useEffect(
    () => () => {
      Notification.clear();
    },
    []
  );

  if (!heading) return null;

  return (
    <NotificationMessage
      heading={heading}
      message={message}
      variant={variant as NotificationVariant}
      removeNotification={removeNotification}
      customClass={customClass}
    >
      {children}
    </NotificationMessage>
  );
};

export default FlashNotification;
